export default __webpack_public_path__ + "static/media/Res.6f15c217.png";